import { isReactElement } from "@/app/(site)/_utils/misc/react"
import React from "react"

export interface StoryTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
    size: "size1" | "size2" | "size3" | "size4"
    children: React.ReactNode
    asChild?: boolean
}

const fontSizeMap = {
    size1: "md:text-48 text-32",
    size2: "md:text-32 text-24",
    size3: "md:text-24 text-16",
    size4: "md:text-16 text-14"
}

const lineHeightMap = {
    size1: "md:leading-100 leading-100",
    size2: "md:leading-120 leading-120",
    size3: "md:leading-130 leading-130",
    size4: "md:leading-130 leading-130"
}

const StoryText: React.FC<StoryTextProps> = ({
    size,
    children,
    className,
    asChild,
    ...props
}) => {
    const fontSize = fontSizeMap[size]
    const lineHeight = lineHeightMap[size]
    const combinedClassNames = `${fontSize} ${lineHeight} font-tradeLight ${className || ""}`

    if (asChild && isReactElement(children)) {
        return React.cloneElement(children, {
            className: `${children.props.className || ""} ${combinedClassNames}`,
            ...props
        })
    }

    return (
        <p className={combinedClassNames} {...props}>
            {children}
        </p>
    )
}

export default StoryText
